interface ApiResponse<T> {
    status: 'success' | 'error';
    data: T;
    message?: string;
}

export const extractDataFromResponse = <T>(response: ApiResponse<T>): T => {
    if (response.status === 'success' && response.data) {
        return response.data;
    }
    throw new Error(response.message || 'Failed to extract data from response');
};

export const extractArrayFromResponse = <T>(response: ApiResponse<T[]>): T[] => {
    if (response.status === 'success' && Array.isArray(response.data)) {
        return response.data;
    }
    throw new Error(response.message || 'Failed to extract array from response');
};

export const extractFileMetadata = (response: ApiResponse<{
    fileName: string;
    fileUrl: string;
    sasToken: string;
    contentType: string;
    fileSize: number;
}>) => {
    const data = extractDataFromResponse(response);
    return {
        FileName: data.fileName,
        FileUrl: data.fileUrl,
        SasToken: data.sasToken,
        ContentType: data.contentType,
        FileSize: data.fileSize || 0
    };
}; 